import { makeStyles } from "@material-ui/core/styles";
import Breakpoints from "common/breakpoints";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  modal: {
    padding: "0 20px 12px",
    borderRadius: 3,
    "&.twoButtonDialog .MuiPaper-root": {
      width: 272
    },
    "&.threeButtonDialog .MuiPaper-root": {
      width: 366
    },
    "& .MuiDialog-paper": {
      [theme.breakpoints.down(Breakpoints.SM_600)]: {
        margin: 0
      }
    }
  }
}));
